export const MAX_DIRECTORY_ENTRIES = 10;
export const ENTRIES_FIELDS =
    'items(id,link,name,order,thumbnail,type,resourceId,resourceProperties),more,callId,cursor';
export const TEMPLATE_PREFIX = 'template-';
export enum ENTRY_TYPES {
    LINK = 'link',
    MICROAPP = 'microapp',
}
